import React from 'react';
import Sidebar from '../components/Sidebar';
import { useNavigate } from 'react-router-dom';
import '../pages/HomePage.css';

const soporteLinks = [
  { to: '/home', label: 'Home' },
  { to: '/tareas-completar', label: 'Tareas a Completar' },
  { to: '/tareas-calificacion', label: 'Tareas por Calificación' },
  { to: '/soporte/ver-tareas-area', label: 'Ver Tareas del Área' },
  { to: '/soporte/crear-usuario', label: 'Crear Usuarios' },
  { to: '/soporte/administrar-usuarios', label: 'Administrar Usuarios' }
];

const SoporteLayout = ({ children }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/auth/login');
  };

  return (
    <div className="home-container">
      <Sidebar links={soporteLinks} onLogout={handleLogout} />
      <main className="home-content">
        {children}
      </main>
    </div>
  );
};

export default SoporteLayout; 